var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
            "margin-bottom": "20px",
          },
        },
        [
          _c("h2", { staticStyle: { margin: "0" } }, [_vm._v("KPI Analytics")]),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                gap: "10px",
              },
            },
            [
              _c("el-date-picker", {
                staticStyle: { width: "280px" },
                attrs: {
                  type: "daterange",
                  "range-separator": "-",
                  "start-placeholder": "Export Start",
                  "end-placeholder": "Export End",
                  "value-format": "yyyy-MM-dd",
                  size: "small",
                },
                model: {
                  value: _vm.exportDateRange,
                  callback: function ($$v) {
                    _vm.exportDateRange = $$v
                  },
                  expression: "exportDateRange",
                },
              }),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "success",
                    icon: "el-icon-download",
                    size: "small",
                    loading: _vm.exportLoading,
                  },
                  on: { click: _vm.exportToExcel },
                },
                [_vm._v("Export Excel")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTabChange },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "Connected Devices", name: "devices" } },
            [
              _c(
                "div",
                { staticClass: "filter-row" },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": "-",
                      "start-placeholder": "Start",
                      "end-placeholder": "End",
                      "value-format": "yyyy-MM-dd",
                      size: "small",
                    },
                    on: { change: _vm.fetchDevices },
                    model: {
                      value: _vm.devicesDateRange,
                      callback: function ($$v) {
                        _vm.devicesDateRange = $$v
                      },
                      expression: "devicesDateRange",
                    },
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px", "margin-left": "10px" },
                      attrs: { size: "small" },
                      on: { change: _vm.fetchDevices },
                      model: {
                        value: _vm.devicesGroupBy,
                        callback: function ($$v) {
                          _vm.devicesGroupBy = $$v
                        },
                        expression: "devicesGroupBy",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "Weekly", value: "week" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Monthly", value: "month" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Quarterly", value: "quarter" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("V1 Devices"),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "stat-value",
                              staticStyle: { color: "#409eff" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.devicesData.summary?.totalV1 || 0)
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("V2 Devices"),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "stat-value",
                              staticStyle: { color: "#67c23a" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.devicesData.summary?.totalV2 || 0)
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("Total"),
                          ]),
                          _c("div", { staticClass: "stat-value" }, [
                            _vm._v(_vm._s(_vm.devicesData.summary?.total || 0)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.devicesLoading,
                      expression: "devicesLoading",
                    },
                  ],
                  attrs: {
                    data: _vm.devicesData.timeSeries || [],
                    border: "",
                    stripe: "",
                    size: "small",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "Period",
                      prop: "period",
                      formatter: (row) =>
                        _vm.formatPeriod(row.period, _vm.devicesGroupBy),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "V1",
                      prop: "V1",
                      width: "120",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              { attrs: { type: "primary", size: "small" } },
                              [_vm._v(_vm._s(row.V1))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "V2",
                      prop: "V2",
                      width: "120",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              { attrs: { type: "success", size: "small" } },
                              [_vm._v(_vm._s(row.V2))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Total", width: "120", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("strong", [_vm._v(_vm._s(row.V1 + row.V2))]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "Activation Rate", name: "activation" } },
            [
              _c(
                "div",
                { staticClass: "filter-row" },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": "-",
                      "start-placeholder": "Start",
                      "end-placeholder": "End",
                      "value-format": "yyyy-MM-dd",
                      size: "small",
                    },
                    on: { change: _vm.fetchActivation },
                    model: {
                      value: _vm.activationDateRange,
                      callback: function ($$v) {
                        _vm.activationDateRange = $$v
                      },
                      expression: "activationDateRange",
                    },
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px", "margin-left": "10px" },
                      attrs: { size: "small" },
                      on: { change: _vm.fetchActivation },
                      model: {
                        value: _vm.activationGroupBy,
                        callback: function ($$v) {
                          _vm.activationGroupBy = $$v
                        },
                        expression: "activationGroupBy",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "Weekly", value: "week" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Monthly", value: "month" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Quarterly", value: "quarter" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("Total Activations"),
                          ]),
                          _c("div", { staticClass: "stat-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.activationData.summary?.totalActivations ||
                                  0
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("Completed"),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "stat-value",
                              staticStyle: { color: "#67c23a" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.activationData.summary?.totalCompleted ||
                                    0
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("Success Rate"),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "stat-value",
                              style: {
                                color:
                                  (_vm.activationData.summary
                                    ?.overallSuccessRate || 0) >= 80
                                    ? "#67c23a"
                                    : "#e6a23c",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.activationData.summary
                                    ?.overallSuccessRate || 0
                                ) + "%"
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.activationLoading,
                      expression: "activationLoading",
                    },
                  ],
                  attrs: {
                    data: _vm.activationData.timeSeries || [],
                    border: "",
                    stripe: "",
                    size: "small",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "Period",
                      prop: "period",
                      formatter: (row) =>
                        _vm.formatPeriod(row.period, _vm.activationGroupBy),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Total",
                      prop: "totalActivations",
                      width: "120",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Completed",
                      prop: "completed",
                      width: "120",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              { attrs: { type: "success", size: "small" } },
                              [_vm._v(_vm._s(row.completed))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Success Rate",
                      prop: "successRate",
                      width: "140",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    row.successRate >= 80
                                      ? "success"
                                      : row.successRate >= 50
                                      ? "warning"
                                      : "danger",
                                  size: "small",
                                },
                              },
                              [_vm._v(_vm._s(row.successRate) + "%")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "New Subscriptions", name: "subscriptions" } },
            [
              _c(
                "div",
                { staticClass: "filter-row" },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": "-",
                      "start-placeholder": "Start",
                      "end-placeholder": "End",
                      "value-format": "yyyy-MM-dd",
                      size: "small",
                    },
                    on: { change: _vm.fetchSubscriptions },
                    model: {
                      value: _vm.subsDateRange,
                      callback: function ($$v) {
                        _vm.subsDateRange = $$v
                      },
                      expression: "subsDateRange",
                    },
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px", "margin-left": "10px" },
                      attrs: { size: "small" },
                      on: { change: _vm.fetchSubscriptions },
                      model: {
                        value: _vm.subsGroupBy,
                        callback: function ($$v) {
                          _vm.subsGroupBy = $$v
                        },
                        expression: "subsGroupBy",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "Weekly", value: "week" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Monthly", value: "month" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Quarterly", value: "quarter" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px", "margin-left": "10px" },
                      attrs: { size: "small" },
                      on: { change: _vm.fetchSubscriptions },
                      model: {
                        value: _vm.subsPlatform,
                        callback: function ($$v) {
                          _vm.subsPlatform = $$v
                        },
                        expression: "subsPlatform",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "All", value: "all" },
                      }),
                      _c("el-option", {
                        attrs: { label: "iOS", value: "ios" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Android", value: "android" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("Total Purchases"),
                          ]),
                          _c("div", { staticClass: "stat-value" }, [
                            _vm._v(
                              _vm._s(_vm.subsData.summary?.totalCount || 0)
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("By Platform"),
                          ]),
                          _c(
                            "div",
                            { staticStyle: { "margin-top": "8px" } },
                            _vm._l(
                              _vm.subsData.summary?.byPlatform || [],
                              function (p) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: p.platform,
                                    staticStyle: { margin: "2px" },
                                    attrs: {
                                      type:
                                        p.platform === "ios" ? "" : "success",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          p.platform === "ios"
                                            ? "iOS"
                                            : "Android"
                                        ) +
                                        ": " +
                                        _vm._s(p.count) +
                                        " "
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("By Feature"),
                          ]),
                          _c(
                            "div",
                            { staticStyle: { "margin-top": "8px" } },
                            _vm._l(
                              _vm.subsData.summary?.byFeatureGroup || [],
                              function (p) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: p.featureGroup,
                                    staticStyle: { margin: "2px" },
                                    attrs: {
                                      type: _vm.featureTagType(p.featureGroup),
                                      size: "small",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.featureLabel(p.featureGroup)
                                        ) +
                                        ": " +
                                        _vm._s(p.count) +
                                        " "
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.subsData.summary?.revenueByCurrency?.length
                ? _c(
                    "el-row",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: { gutter: 20 },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass: "stat-card",
                              attrs: { shadow: "hover" },
                            },
                            [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v("Total Revenue by Currency"),
                              ]),
                              _c(
                                "div",
                                { staticStyle: { "margin-top": "8px" } },
                                _vm._l(
                                  _vm.subsData.summary.revenueByCurrency,
                                  function (r) {
                                    return _c(
                                      "el-tag",
                                      {
                                        key: r.currency,
                                        staticStyle: {
                                          margin: "4px",
                                          "font-size": "14px",
                                        },
                                        attrs: { type: "warning" },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(r.total.toFixed(2)) +
                                            " " +
                                            _vm._s(r.currency) +
                                            " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-card",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { shadow: "hover" },
                },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("strong", [_vm._v("Summary by Period")]),
                  ]),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.subsLoading,
                          expression: "subsLoading",
                        },
                      ],
                      attrs: {
                        data: _vm.subsGroupedByPeriod,
                        border: "",
                        stripe: "",
                        size: "small",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "Period",
                          prop: "period",
                          width: "120",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Total",
                          prop: "total",
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [_c("strong", [_vm._v(_vm._s(row.total))])]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "iOS",
                          prop: "ios",
                          width: "80",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("el-tag", { attrs: { size: "small" } }, [
                                  _vm._v(_vm._s(row.ios)),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Android",
                          prop: "android",
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  { attrs: { type: "success", size: "small" } },
                                  [_vm._v(_vm._s(row.android))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Smart Map",
                          prop: "smart_map",
                          width: "110",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                row.smart_map
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: "warning",
                                          size: "small",
                                        },
                                      },
                                      [_vm._v(_vm._s(row.smart_map))]
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Voice Assistant",
                          prop: "voice_assistant",
                          width: "130",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                row.voice_assistant
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: "success",
                                          size: "small",
                                        },
                                      },
                                      [_vm._v(_vm._s(row.voice_assistant))]
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "WeASSIST",
                          prop: "weassist",
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                row.weassist
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: { type: "info", size: "small" },
                                      },
                                      [_vm._v(_vm._s(row.weassist))]
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Other",
                          prop: "other",
                          width: "80",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("span", [_vm._v(_vm._s(row.other || "-"))]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { shadow: "hover" } },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("strong", [_vm._v("Detail by Product")]),
                  ]),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.subsLoading,
                          expression: "subsLoading",
                        },
                      ],
                      attrs: {
                        data: _vm.subsData.timeSeries || [],
                        border: "",
                        stripe: "",
                        size: "small",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "Period",
                          prop: "period",
                          formatter: (row) =>
                            _vm.formatPeriod(row.period, _vm.subsGroupBy),
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Platform",
                          prop: "platform",
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type:
                                        row.platform === "ios" ? "" : "success",
                                      size: "small",
                                    },
                                  },
                                  [_vm._v(_vm._s(row.platform))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Product",
                          prop: "productId",
                          "min-width": "200",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Feature",
                          prop: "featureGroup",
                          width: "140",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                row.featureGroup
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.featureTagType(
                                            row.featureGroup
                                          ),
                                          size: "small",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.featureLabel(row.featureGroup)
                                          )
                                        ),
                                      ]
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Count",
                          prop: "count",
                          width: "100",
                          align: "center",
                          sortable: "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Revenue",
                          "min-width": "180",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                row.revenueByCurrency &&
                                row.revenueByCurrency.length
                                  ? _c(
                                      "span",
                                      _vm._l(
                                        row.revenueByCurrency,
                                        function (r) {
                                          return _c(
                                            "el-tag",
                                            {
                                              key: r.currency,
                                              staticStyle: { margin: "1px" },
                                              attrs: { size: "mini" },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(r.amount.toFixed(2)) +
                                                  " " +
                                                  _vm._s(r.currency) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "Store Ratings (CSAT)", name: "ratings" } },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _c("i", { staticClass: "el-icon-apple" }),
                            _vm._v(" App Store Rating"),
                          ]),
                          _c("div", { staticClass: "stat-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.ratingsData.apple?.globalRating || "-"
                              ) + " "
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "14px",
                                  color: "#909399",
                                },
                              },
                              [_vm._v("/ 5")]
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#909399",
                                "margin-top": "4px",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.ratingsData.apple?.globalRatingCount || 0
                                ) +
                                  " ratings across " +
                                  _vm._s(
                                    (_vm.ratingsData.apple?.byCountry || [])
                                      .length
                                  ) +
                                  " countries"
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _c("i", { staticClass: "el-icon-mobile-phone" }),
                            _vm._v(" Google Play Rating"),
                          ]),
                          _c("div", { staticClass: "stat-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.ratingsData.google?.globalRating || "-"
                              ) + " "
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "14px",
                                  color: "#909399",
                                },
                              },
                              [_vm._v("/ 5")]
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#909399",
                                "margin-top": "4px",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.ratingsData.google?.globalRatingCount || 0
                                ) + " ratings"
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("Written Reviews"),
                          ]),
                          _c("div", { staticClass: "stat-value" }, [
                            _vm._v(
                              _vm._s(_vm.appleReviewCount) +
                                " + " +
                                _vm._s(_vm.googleReviewCount)
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#909399",
                                "margin-top": "4px",
                              },
                            },
                            [
                              _vm._v(
                                "App Store (" +
                                  _vm._s(_vm.appleReviewCount) +
                                  ") + Google Play (" +
                                  _vm._s(_vm.googleReviewCount) +
                                  ")"
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center",
                      },
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("strong", [_vm._v("Ratings & Reviews")]),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "120px" },
                          attrs: { size: "small" },
                          model: {
                            value: _vm.ratingsGroupBy,
                            callback: function ($$v) {
                              _vm.ratingsGroupBy = $$v
                            },
                            expression: "ratingsGroupBy",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "Weekly", value: "week" },
                          }),
                          _c("el-option", {
                            attrs: { label: "Monthly", value: "month" },
                          }),
                          _c("el-option", {
                            attrs: { label: "Quarterly", value: "quarter" },
                          }),
                          _c("el-option", {
                            attrs: { label: "Yearly", value: "year" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.ratingsLoading,
                          expression: "ratingsLoading",
                        },
                      ],
                      attrs: {
                        data: _vm.ratingsTableData,
                        border: "",
                        stripe: "",
                        size: "small",
                        "row-key": "key",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "expand" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { padding: "10px 20px" } },
                                  [
                                    _c(
                                      "el-table",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          data: row.reviews,
                                          border: "",
                                          size: "mini",
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "Store",
                                            width: "90",
                                            align: "center",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ row: r }) {
                                                  return [
                                                    _c(
                                                      "el-tag",
                                                      {
                                                        attrs: {
                                                          type:
                                                            r.store ===
                                                            "App Store"
                                                              ? ""
                                                              : "success",
                                                          size: "mini",
                                                        },
                                                      },
                                                      [_vm._v(_vm._s(r.store))]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "Rating",
                                            width: "70",
                                            align: "center",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ row: r }) {
                                                  return [
                                                    _c(
                                                      "el-tag",
                                                      {
                                                        attrs: {
                                                          type:
                                                            r.rating >= 4
                                                              ? "success"
                                                              : r.rating >= 3
                                                              ? "warning"
                                                              : "danger",
                                                          size: "mini",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(r.rating) +
                                                            "/5"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "Country",
                                            prop: "country",
                                            width: "80",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "Date",
                                            width: "100",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ row: r }) {
                                                  return [
                                                    _vm._v(
                                                      _vm._s(
                                                        r.date
                                                          ? r.date.substring(
                                                              0,
                                                              10
                                                            )
                                                          : "-"
                                                      )
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "User",
                                            width: "140",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ row: r }) {
                                                  return [
                                                    _vm._v(
                                                      _vm._s(r.reviewer || "-")
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "Title",
                                            prop: "title",
                                            width: "180",
                                            "show-overflow-tooltip": "",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "Review",
                                            prop: "body",
                                            "min-width": "300",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ row: r }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "white-space":
                                                            "pre-wrap",
                                                          "max-height": "100px",
                                                          "overflow-y": "auto",
                                                          "font-size": "12px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(r.body || "-")
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Period",
                          prop: "period",
                          width: "130",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Country",
                          prop: "country",
                          width: "80",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Rating", width: "200" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "inline-flex",
                                      "align-items": "center",
                                      gap: "8px",
                                    },
                                  },
                                  [
                                    _c("el-rate", {
                                      staticStyle: {
                                        display: "inline-block",
                                        "line-height": "1",
                                      },
                                      attrs: {
                                        value: row.avgRating,
                                        disabled: "",
                                      },
                                    }),
                                    _c("strong", [
                                      _vm._v(_vm._s(row.avgRating)),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Reviews",
                          prop: "count",
                          width: "90",
                          align: "center",
                          sortable: "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Distribution", "min-width": "180" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return _vm._l([5, 4, 3, 2, 1], function (n) {
                                return _c(
                                  "span",
                                  {
                                    key: n,
                                    staticStyle: { "margin-right": "3px" },
                                  },
                                  [
                                    row.ratingDist[n]
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type:
                                                n >= 4
                                                  ? "success"
                                                  : n >= 3
                                                  ? "warning"
                                                  : "danger",
                                              size: "mini",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(n) +
                                                "★ " +
                                                _vm._s(row.ratingDist[n]) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              })
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "OTA vs Connections", name: "ota" } },
            [
              _c(
                "div",
                { staticClass: "filter-row" },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": "-",
                      "start-placeholder": "Start",
                      "end-placeholder": "End",
                      "value-format": "yyyy-MM-dd",
                      size: "small",
                    },
                    on: { change: _vm.fetchOta },
                    model: {
                      value: _vm.otaDateRange,
                      callback: function ($$v) {
                        _vm.otaDateRange = $$v
                      },
                      expression: "otaDateRange",
                    },
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px", "margin-left": "10px" },
                      attrs: { size: "small" },
                      on: { change: _vm.fetchOta },
                      model: {
                        value: _vm.otaGroupBy,
                        callback: function ($$v) {
                          _vm.otaGroupBy = $$v
                        },
                        expression: "otaGroupBy",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "Weekly", value: "week" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Monthly", value: "month" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Quarterly", value: "quarter" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("OTA Updated Users"),
                          ]),
                          _c("div", { staticClass: "stat-value" }, [
                            _vm._v(_vm._s(_vm.otaData.summary?.totalOta || 0)),
                          ]),
                          _c("div", { staticClass: "stat-sub" }, [
                            _vm._v("Unique users who downloaded OTA"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("New Connections (Pair)"),
                          ]),
                          _c("div", { staticClass: "stat-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.otaData.summary?.totalNewConnections || 0
                              )
                            ),
                          ]),
                          _c("div", { staticClass: "stat-sub" }, [
                            _vm._v("Unique devices paired"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("Active Devices"),
                          ]),
                          _c("div", { staticClass: "stat-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.otaData.summary?.activeDeviceCount || 0
                              )
                            ),
                          ]),
                          _c("div", { staticClass: "stat-sub" }, [
                            _vm._v("Currently active devices"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("OTA Adoption Rate"),
                          ]),
                          _c("div", { staticClass: "stat-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.otaData.summary?.overallAdoptionRate || 0
                              ) + "%"
                            ),
                          ]),
                          _c("div", { staticClass: "stat-sub" }, [
                            _vm._v("OTA Users / Active Devices"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.otaLoading,
                      expression: "otaLoading",
                    },
                  ],
                  attrs: {
                    data: _vm.otaData.timeSeries || [],
                    border: "",
                    stripe: "",
                    size: "small",
                    "row-key": "period",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "expand" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.versions && row.versions.length
                              ? _c(
                                  "div",
                                  { staticStyle: { padding: "10px 20px" } },
                                  [
                                    _c(
                                      "h4",
                                      { staticStyle: { margin: "0 0 10px 0" } },
                                      [_vm._v("OTA Version Breakdown")]
                                    ),
                                    _c(
                                      "el-table",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          data: row.versions,
                                          border: "",
                                          size: "mini",
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "App Version",
                                            prop: "appVersion",
                                            width: "130",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "Wireless Version",
                                            prop: "wirelessVersion",
                                            width: "140",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "Description",
                                            prop: "description",
                                            "min-width": "200",
                                            "show-overflow-tooltip": "",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "Unique Users",
                                            prop: "uniqueUsers",
                                            width: "120",
                                            align: "center",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ row: vRow }) {
                                                  return [
                                                    _c(
                                                      "el-tag",
                                                      {
                                                        attrs: {
                                                          type: "primary",
                                                          size: "mini",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            vRow.uniqueUsers
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "Total Downloads",
                                            prop: "totalDownloads",
                                            width: "130",
                                            align: "center",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ row: vRow }) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#909399",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            vRow.totalDownloads
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      padding: "10px 20px",
                                      color: "#909399",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "No version data available for this period."
                                    ),
                                  ]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Period",
                      prop: "period",
                      formatter: (row) =>
                        _vm.formatPeriod(row.period, _vm.otaGroupBy),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "OTA Users",
                      prop: "otaCount",
                      width: "120",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "New Connections (Pair)",
                      prop: "newConnections",
                      width: "150",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Adoption Rate",
                      prop: "adoptionRate",
                      width: "130",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    row.adoptionRate > 5
                                      ? "success"
                                      : "warning",
                                  size: "small",
                                },
                              },
                              [_vm._v(_vm._s(row.adoptionRate) + "%")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Versions", width: "90", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              { attrs: { type: "info", size: "mini" } },
                              [_vm._v(_vm._s((row.versions || []).length))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "OTA Versions", name: "otaVersions" } },
            [
              _c(
                "div",
                { staticClass: "filter-row" },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": "-",
                      "start-placeholder": "Start",
                      "end-placeholder": "End",
                      "value-format": "yyyy-MM-dd",
                      size: "small",
                    },
                    on: { change: _vm.fetchOtaVersions },
                    model: {
                      value: _vm.otaVersionDateRange,
                      callback: function ($$v) {
                        _vm.otaVersionDateRange = $$v
                      },
                      expression: "otaVersionDateRange",
                    },
                  }),
                ],
                1
              ),
              _vm.otaVersionData.summary
                ? _c(
                    "el-row",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: { gutter: 20 },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass: "stat-card",
                              attrs: { shadow: "hover" },
                            },
                            [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v("Total Devices with OTA"),
                              ]),
                              _c("div", { staticClass: "stat-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.otaVersionData.summary.totalDevices
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass: "stat-card",
                              attrs: { shadow: "hover" },
                            },
                            [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v("On Latest (any track)"),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "stat-value",
                                  staticStyle: { color: "#67c23a" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.otaVersionData.summary.onLatestVersion
                                    )
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "stat-sub" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("kpiAnalytics.latestCombined"))
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass: "stat-card",
                              attrs: { shadow: "hover" },
                            },
                            [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v("Latest Adoption Rate"),
                              ]),
                              _c("div", { staticClass: "stat-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.otaVersionData.summary.latestVersionRate
                                  ) + "%"
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.otaVersionData.summary &&
              _vm.otaVersionData.summary.latestVersions &&
              _vm.otaVersionData.summary.latestVersions.length
                ? _c(
                    "el-card",
                    {
                      staticClass: "latest-versions-card",
                      staticStyle: { "margin-bottom": "16px" },
                      attrs: { shadow: "never" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            gap: "8px",
                          },
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("strong", [_vm._v("Current Latest Versions")]),
                          _c(
                            "el-tag",
                            { attrs: { type: "success", size: "mini" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.otaVersionData.summary.latestVersions
                                    .length
                                ) + " track"
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#909399",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("kpiAnalytics.latestRowsHint"))
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.otaVersionData.summary.latestVersions,
                            border: "",
                            size: "small",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "Track",
                              width: "100",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            size: "small",
                                            type:
                                              row.majorVersion === "3"
                                                ? "primary"
                                                : "success",
                                          },
                                        },
                                        [_vm._v("V" + _vm._s(row.majorVersion))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3490201851
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "App Version",
                              prop: "appVersion",
                              width: "150",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Wireless Version",
                              prop: "wirelessVersion",
                              width: "180",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Released", width: "180" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDateTime(row.releasedAt)
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3025610276
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Description",
                              prop: "description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.otaVersionData.summary &&
              _vm.otaVersionData.summary.channels &&
              _vm.otaVersionData.summary.channels.length
                ? _c(
                    "el-card",
                    {
                      staticStyle: { "margin-bottom": "16px" },
                      attrs: { shadow: "never" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            gap: "8px",
                          },
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("strong", [_vm._v("Adoption by Channel")]),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#909399",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("kpiAnalytics.channelBuildHint"))
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.otaVersionData.summary.channels,
                            border: "",
                            size: "small",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "Channel", width: "180" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            size: "small",
                                            type:
                                              row.groupId === null
                                                ? "info"
                                                : "warning",
                                          },
                                        },
                                        [_vm._v(_vm._s(row.channelName))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2837761267
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Target Build(s)",
                              "min-width": "220",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      !row.latestVersions.length
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#c0c4cc" },
                                            },
                                            [_vm._v("no build")]
                                          )
                                        : _vm._e(),
                                      _vm._l(row.latestVersions, function (v) {
                                        return _c(
                                          "el-tag",
                                          {
                                            key: v.appVersion,
                                            staticStyle: {
                                              "margin-right": "6px",
                                            },
                                            attrs: { size: "mini" },
                                          },
                                          [
                                            _vm._v(
                                              " V" +
                                                _vm._s(v.majorVersion) +
                                                ": " +
                                                _vm._s(v.appVersion) +
                                                " / " +
                                                _vm._s(v.wirelessVersion) +
                                                " "
                                            ),
                                          ]
                                        )
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3270523290
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Devices",
                              prop: "totalDevices",
                              width: "100",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "On Latest",
                              prop: "onLatestVersion",
                              width: "110",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Adoption",
                              width: "180",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("el-progress", {
                                        attrs: {
                                          percentage: row.latestVersionRate,
                                          "stroke-width": 14,
                                          "text-inside": true,
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              881656681
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "h4",
                { staticStyle: { margin: "16px 0 8px 0", color: "#606266" } },
                [_vm._v("Devices by Version")]
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.otaVersionLoading,
                      expression: "otaVersionLoading",
                    },
                  ],
                  attrs: {
                    data: _vm.otaVersionData.distribution || [],
                    border: "",
                    stripe: "",
                    size: "small",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "Track", width: "80", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.major_version
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type:
                                        row.major_version === "3"
                                          ? "primary"
                                          : row.major_version === "2"
                                          ? "success"
                                          : "info",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " V" + _vm._s(row.major_version) + " "
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  { staticStyle: { color: "#c0c4cc" } },
                                  [_vm._v("—")]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Channel", width: "140" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  size: "mini",
                                  type:
                                    row.group_id === null ? "info" : "warning",
                                },
                              },
                              [_vm._v(_vm._s(row.channel_name || "Stable"))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "App Version",
                      prop: "app_version",
                      width: "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Wireless Version",
                      prop: "wireless_version",
                      width: "160",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Device Count",
                      prop: "device_count",
                      width: "130",
                      align: "center",
                      sortable: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("strong", [_vm._v(_vm._s(row.device_count))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Percentage",
                      width: "150",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("el-progress", {
                              attrs: {
                                percentage: _vm.otaVersionData.summary
                                  ? Math.round(
                                      (row.device_count /
                                        _vm.otaVersionData.summary
                                          .totalDevices) *
                                        100
                                    )
                                  : 0,
                                "stroke-width": 14,
                                "text-inside": true,
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Status", width: "120", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.is_latest
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "success", size: "mini" } },
                                  [_vm._v("Latest")]
                                )
                              : _c(
                                  "el-tag",
                                  { attrs: { type: "warning", size: "mini" } },
                                  [_vm._v("Old")]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "App Downloads", name: "downloads" } },
            [
              _c(
                "div",
                { staticClass: "filter-row" },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": "-",
                      "start-placeholder": "Start",
                      "end-placeholder": "End",
                      "value-format": "yyyy-MM-dd",
                      size: "small",
                    },
                    on: { change: _vm.fetchDownloads },
                    model: {
                      value: _vm.downloadsDateRange,
                      callback: function ($$v) {
                        _vm.downloadsDateRange = $$v
                      },
                      expression: "downloadsDateRange",
                    },
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px", "margin-left": "10px" },
                      attrs: { size: "small" },
                      on: { change: _vm.fetchDownloads },
                      model: {
                        value: _vm.downloadsGroupBy,
                        callback: function ($$v) {
                          _vm.downloadsGroupBy = $$v
                        },
                        expression: "downloadsGroupBy",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "Daily", value: "day" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Weekly", value: "week" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Monthly", value: "month" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Quarterly", value: "quarter" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: {
                        size: "small",
                        icon: "el-icon-refresh",
                        loading: _vm.downloadsLoading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.fetchDownloads(true)
                        },
                      },
                    },
                    [_vm._v("Refresh")]
                  ),
                  _vm.downloadsData.cachedAt
                    ? _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "12px",
                            color: "#909399",
                            "margin-left": "10px",
                          },
                        },
                        [
                          _vm._v(
                            "Data as of " +
                              _vm._s(
                                _vm.formatDateTime(_vm.downloadsData.cachedAt)
                              ) +
                              " (store data is cached for 1 hour)"
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("el-alert", {
                staticStyle: { "margin-bottom": "15px" },
                attrs: {
                  type: "info",
                  closable: false,
                  "show-icon": "",
                  title:
                    "Store totals are anonymous install counts reported by Apple and Google; they are not user accounts. Apple reports downloads only. Google additionally reports user installs (unique accounts), device installs, uninstalls and active devices, so the two columns cannot be compared one to one. For the people who registered in a period use the New Registrations tab.",
                },
              }),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-card",
                        { attrs: { shadow: "hover" } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [_c("strong", [_vm._v("Apple App Store")])]
                          ),
                          _vm.downloadsData.apple?.available
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-row",
                                    {
                                      staticStyle: { "margin-bottom": "15px" },
                                      attrs: { gutter: 10 },
                                    },
                                    [
                                      _c("el-col", { attrs: { span: 8 } }, [
                                        _c(
                                          "div",
                                          { staticClass: "stat-card" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "stat-label" },
                                              [_vm._v("Total Downloads")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "stat-value",
                                                staticStyle: {
                                                  "font-size": "22px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.downloadsData.apple
                                                      .summary
                                                      ?.totalDownloads || 0
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c("el-col", { attrs: { span: 16 } }, [
                                        _c(
                                          "div",
                                          { staticClass: "stat-card" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "stat-label" },
                                              [_vm._v("Top Countries")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "margin-top": "4px",
                                                },
                                              },
                                              _vm._l(
                                                (
                                                  _vm.downloadsData.apple
                                                    .summary?.byCountry || []
                                                ).slice(0, 8),
                                                function (c) {
                                                  return _c(
                                                    "el-tag",
                                                    {
                                                      key: c.country,
                                                      staticStyle: {
                                                        margin: "2px",
                                                      },
                                                      attrs: { size: "mini" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(c.country) +
                                                          ": " +
                                                          _vm._s(c.count)
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-table",
                                    {
                                      attrs: {
                                        data:
                                          _vm.downloadsData.apple.series ||
                                          _vm.downloadsData.apple.data ||
                                          [],
                                        border: "",
                                        stripe: "",
                                        size: "small",
                                        "max-height": "420",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.downloadsPeriodLabel,
                                          prop: "period",
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ row }) {
                                                return [
                                                  _vm._v(
                                                    _vm._s(
                                                      row.period || row.date
                                                    )
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3090926314
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Downloads",
                                          prop: "totalCount",
                                          width: "120",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ row }) {
                                                return [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(row.totalCount)
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2706970650
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Days",
                                          prop: "days",
                                          width: "80",
                                          align: "center",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c("el-alert", {
                                attrs: {
                                  title:
                                    _vm.downloadsData.apple?.note ||
                                    "Apple Analytics reports are being generated.",
                                  type: "info",
                                  closable: false,
                                  "show-icon": "",
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-card",
                        { attrs: { shadow: "hover" } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [_c("strong", [_vm._v("Google Play")])]
                          ),
                          _vm.downloadsData.google?.available
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-row",
                                    {
                                      staticStyle: { "margin-bottom": "15px" },
                                      attrs: { gutter: 10 },
                                    },
                                    [
                                      _c("el-col", { attrs: { span: 8 } }, [
                                        _c(
                                          "div",
                                          { staticClass: "stat-card" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "stat-label" },
                                              [_vm._v("Total Installs")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "stat-value",
                                                staticStyle: {
                                                  "font-size": "22px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.downloadsData.google
                                                      .summary?.totalInstalls ||
                                                      0
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c("el-col", { attrs: { span: 8 } }, [
                                        _c(
                                          "div",
                                          { staticClass: "stat-card" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "stat-label" },
                                              [_vm._v("Active Devices")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "stat-value",
                                                staticStyle: {
                                                  "font-size": "22px",
                                                  color: "#67c23a",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.downloadsData.google
                                                      .summary?.activeDevices ||
                                                      0
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c("el-col", { attrs: { span: 8 } }, [
                                        _c(
                                          "div",
                                          { staticClass: "stat-card" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "stat-label" },
                                              [_vm._v("Uninstalls")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "stat-value",
                                                staticStyle: {
                                                  "font-size": "22px",
                                                  color: "#f56c6c",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.downloadsData.google
                                                      .summary
                                                      ?.totalUninstalls || 0
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-table",
                                    {
                                      attrs: {
                                        data:
                                          _vm.downloadsData.google.series ||
                                          _vm.downloadsData.google.data ||
                                          [],
                                        border: "",
                                        stripe: "",
                                        size: "small",
                                        "max-height": "420",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.downloadsPeriodLabel,
                                          prop: "period",
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ row }) {
                                                return [
                                                  _vm._v(
                                                    _vm._s(
                                                      row.period || row.month
                                                    )
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          417091886
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Device Installs",
                                          prop: "totalInstalls",
                                          width: "130",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ row }) {
                                                return [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(row.totalInstalls)
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3865827563
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "User Installs",
                                          prop: "totalUserInstalls",
                                          width: "120",
                                          align: "center",
                                        },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Uninstalls",
                                          prop: "totalUninstalls",
                                          width: "100",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ row }) {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#f56c6c",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          row.totalUninstalls
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4000816097
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Active Devices",
                                          prop: "lastActiveDevices",
                                          width: "130",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ row }) {
                                                return [
                                                  _c(
                                                    "el-tag",
                                                    {
                                                      attrs: {
                                                        type: "success",
                                                        size: "small",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          row.lastActiveDevices
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          448143976
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm.downloadsData.google.summary?.byCountry
                                    ?.length
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: { "margin-top": "15px" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "stat-label",
                                              staticStyle: {
                                                "margin-bottom": "8px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "Top Countries (Last Month)"
                                              ),
                                            ]
                                          ),
                                          _vm._l(
                                            _vm.downloadsData.google.summary.byCountry.slice(
                                              0,
                                              10
                                            ),
                                            function (c) {
                                              return _c(
                                                "el-tag",
                                                {
                                                  key: c.country,
                                                  staticStyle: {
                                                    margin: "2px",
                                                  },
                                                  attrs: { size: "small" },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(c.country) +
                                                      ": " +
                                                      _vm._s(c.count)
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c("el-alert", {
                                attrs: {
                                  title:
                                    _vm.downloadsData.google?.note ||
                                    "Google Play data not available.",
                                  type: "warning",
                                  closable: false,
                                  "show-icon": "",
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "New Registrations", name: "registrations" } },
            [
              _c("el-alert", {
                staticStyle: { "margin-bottom": "15px" },
                attrs: {
                  title: _vm.$t("kpiAnalytics.registrationsInfo"),
                  type: "info",
                  closable: false,
                  "show-icon": "",
                },
              }),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-bottom": "15px",
                    display: "flex",
                    "flex-wrap": "wrap",
                    gap: "10px",
                    "align-items": "center",
                  },
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "260px" },
                    attrs: {
                      type: "daterange",
                      "range-separator": "→",
                      "start-placeholder": "Start",
                      "end-placeholder": "End",
                      "value-format": "yyyy-MM-dd",
                      size: "small",
                    },
                    model: {
                      value: _vm.regDateRange,
                      callback: function ($$v) {
                        _vm.regDateRange = $$v
                      },
                      expression: "regDateRange",
                    },
                  }),
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      on: { change: _vm.applyRegPreset },
                      model: {
                        value: _vm.regPreset,
                        callback: function ($$v) {
                          _vm.regPreset = $$v
                        },
                        expression: "regPreset",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "today" } }, [
                        _vm._v("Today"),
                      ]),
                      _c("el-radio-button", { attrs: { label: "yesterday" } }, [
                        _vm._v("Yesterday"),
                      ]),
                      _c("el-radio-button", { attrs: { label: "7d" } }, [
                        _vm._v("Last 7 days"),
                      ]),
                      _c("el-radio-button", { attrs: { label: "30d" } }, [
                        _vm._v("Last 30 days"),
                      ]),
                      _c("el-radio-button", { attrs: { label: "mtd" } }, [
                        _vm._v("Month to date"),
                      ]),
                    ],
                    1
                  ),
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      placeholder: "Search email / name",
                      size: "small",
                      clearable: "",
                    },
                    model: {
                      value: _vm.regSearch,
                      callback: function ($$v) {
                        _vm.regSearch = $$v
                      },
                      expression: "regSearch",
                    },
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "140px" },
                      attrs: {
                        placeholder: "Login type",
                        size: "small",
                        clearable: "",
                      },
                      model: {
                        value: _vm.regLoginType,
                        callback: function ($$v) {
                          _vm.regLoginType = $$v
                        },
                        expression: "regLoginType",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "All", value: "" } }),
                      _c("el-option", {
                        attrs: { label: "email", value: "email" },
                      }),
                      _c("el-option", {
                        attrs: { label: "apple", value: "apple" },
                      }),
                      _c("el-option", {
                        attrs: { label: "google", value: "google" },
                      }),
                      _c("el-option", {
                        attrs: { label: "phone", value: "phone" },
                      }),
                    ],
                    1
                  ),
                  _c("el-input", {
                    staticStyle: { width: "150px" },
                    attrs: {
                      placeholder: "Country (e.g. tr)",
                      size: "small",
                      clearable: "",
                    },
                    model: {
                      value: _vm.regCountry,
                      callback: function ($$v) {
                        _vm.regCountry = $$v
                      },
                      expression: "regCountry",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-search",
                        loading: _vm.regLoading,
                      },
                      on: { click: _vm.fetchRegistrations },
                    },
                    [_vm._v("Apply")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        icon: "el-icon-download",
                        loading: _vm.regExporting,
                      },
                      on: { click: _vm.exportRegistrations },
                    },
                    [_vm._v("Export Excel")]
                  ),
                  _c(
                    "el-link",
                    {
                      staticStyle: {
                        "font-size": "13px",
                        "margin-left": "auto",
                      },
                      attrs: {
                        type: "primary",
                        underline: false,
                        href: "#/app-settings/reporting",
                        target: "_blank",
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-message" }),
                      _vm._v(" Configure auto email "),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "15px" },
                  attrs: { gutter: 10 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "never" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("Total"),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "stat-value",
                              staticStyle: { "font-size": "22px" },
                            },
                            [_vm._v(_vm._s(_vm.regData.total || 0))]
                          ),
                          _c("div", { staticClass: "stat-sub" }, [
                            _vm._v(
                              _vm._s(_vm.regData.filters?.startDate || "") +
                                " → " +
                                _vm._s(_vm.regData.filters?.endDate || "")
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "never" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("iOS (est.)"),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "stat-value",
                              staticStyle: {
                                "font-size": "22px",
                                color: "#1890ff",
                              },
                            },
                            [_vm._v(_vm._s(_vm.regPlatformCount("ios")))]
                          ),
                          _c("div", { staticClass: "stat-sub" }, [
                            _vm._v("login_type = apple"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "never" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("Android (est.)"),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "stat-value",
                              staticStyle: {
                                "font-size": "22px",
                                color: "#52c41a",
                              },
                            },
                            [_vm._v(_vm._s(_vm.regPlatformCount("android")))]
                          ),
                          _c("div", { staticClass: "stat-sub" }, [
                            _vm._v("login_type = google"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "never" },
                        },
                        [
                          _c("div", { staticClass: "stat-label" }, [
                            _vm._v("Unknown platform"),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "stat-value",
                              staticStyle: {
                                "font-size": "22px",
                                color: "#999",
                              },
                            },
                            [_vm._v(_vm._s(_vm.regPlatformCount("unknown")))]
                          ),
                          _c("div", { staticClass: "stat-sub" }, [
                            _vm._v("email / phone login"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                {
                  staticStyle: { "margin-bottom": "15px" },
                  attrs: { shadow: "never" },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c("strong", [_vm._v("Countries")]),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "12px",
                            color: "#909399",
                            "margin-left": "8px",
                          },
                        },
                        [_vm._v("Click a country to filter the list below.")]
                      ),
                      _vm.regCountry
                        ? _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "8px" },
                              attrs: { size: "mini" },
                              on: { click: _vm.clearRegCountry },
                            },
                            [_vm._v("Clear filter: " + _vm._s(_vm.regCountry))]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.regData.summary?.byCountry?.length
                    ? _c(
                        "div",
                        _vm._l(
                          _vm.regData.summary.byCountry.slice(0, 30),
                          function (c) {
                            return _c(
                              "el-tag",
                              {
                                key: c.country,
                                staticStyle: {
                                  margin: "3px",
                                  cursor: "pointer",
                                },
                                attrs: {
                                  size: "small",
                                  effect:
                                    _vm.regCountry &&
                                    _vm.regCountry.toLowerCase() ===
                                      c.country.toLowerCase()
                                      ? "dark"
                                      : "plain",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.pickRegCountry(c.country)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(c.country) + ": " + _vm._s(c.count)
                                ),
                              ]
                            )
                          }
                        ),
                        1
                      )
                    : _c("el-empty", {
                        attrs: {
                          description: "No data for this range",
                          "image-size": 60,
                        },
                      }),
                ],
                1
              ),
              _vm.regData.summary?.byDay?.length
                ? _c(
                    "el-card",
                    {
                      staticStyle: { "margin-bottom": "15px" },
                      attrs: { shadow: "never" },
                    },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c("strong", [_vm._v("Daily breakdown")]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              color: "#909399",
                              "margin-left": "8px",
                            },
                          },
                          [
                            _vm._v(
                              "Click a row to filter the list to that day."
                            ),
                          ]
                        ),
                      ]),
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.regData.summary.byDay,
                            size: "mini",
                            border: "",
                            stripe: "",
                            "max-height": "240",
                            "row-style": { cursor: "pointer" },
                          },
                          on: { "row-click": _vm.pickRegDay },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "day",
                              label: "Day (UTC)",
                              width: "130",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "count",
                              label: "Users",
                              width: "100",
                              align: "right",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.regLoading,
                      expression: "regLoading",
                    },
                  ],
                  attrs: {
                    data: _vm.regData.rows || [],
                    border: "",
                    stripe: "",
                    size: "small",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "Registered (UTC)", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "div",
                              { staticStyle: { "font-size": "12px" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.formatDateTime(row.createdAt))
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Name", "min-width": "180" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("div", [_vm._v(_vm._s(row.fullName || "—"))]),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "11px",
                                  color: "#888",
                                },
                              },
                              [_vm._v(_vm._s(row.userId))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Email",
                      prop: "email",
                      "min-width": "200",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Phone", "min-width": "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  row.phoneNumber
                                    ? row.countryCode
                                      ? "+" +
                                        row.countryCode +
                                        " " +
                                        row.phoneNumber
                                      : row.phoneNumber
                                    : "—"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Location", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("div", [_vm._v(_vm._s(row.country || "—"))]),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "11px",
                                  color: "#888",
                                },
                              },
                              [_vm._v(_vm._s(row.city || ""))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Platform", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.estPlatform === "ios"
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "", size: "mini" } },
                                  [_vm._v("iOS")]
                                )
                              : row.estPlatform === "android"
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "success", size: "mini" } },
                                  [_vm._v("Android")]
                                )
                              : _c(
                                  "el-tag",
                                  { attrs: { type: "info", size: "mini" } },
                                  [_vm._v("?")]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Login",
                      prop: "loginType",
                      width: "90",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Premium", width: "80", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.isPremium
                              ? _c("i", {
                                  staticClass: "el-icon-check",
                                  staticStyle: { color: "#52c41a" },
                                })
                              : _c("span", { staticStyle: { color: "#ccc" } }, [
                                  _vm._v("—"),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Cane",
                      prop: "caneId",
                      width: "160",
                      "show-overflow-tooltip": "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-top": "12px",
                    display: "flex",
                    "justify-content": "flex-end",
                  },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.regPage,
                      "page-size": _vm.regPageSize,
                      "page-sizes": [25, 50, 100, 200],
                      layout: "total, sizes, prev, pager, next",
                      total: _vm.regData.total || 0,
                    },
                    on: {
                      "update:currentPage": function ($event) {
                        _vm.regPage = $event
                      },
                      "update:current-page": function ($event) {
                        _vm.regPage = $event
                      },
                      "current-change": _vm.fetchRegistrations,
                      "size-change": _vm.onRegPageSizeChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }